import {
  TripLog, TripLogApi, // eslint-disable-line no-unused-vars
} from '@clients/myTrips'
import { AxiosPromise } from 'axios' // eslint-disable-line no-unused-vars
import appendCredentials from '@util/appendCredentials'
import getBasePath from '@util/path'

let basePath = getBasePath() + '/my-trips'

export default class ExtendedTriplogApi extends TripLogApi {
  tripLogsGet (options?: any): AxiosPromise<Array<TripLog>> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.tripLogsGet(undefined, optionsParam)
  }
}
